import { render, staticRenderFns } from "./ClassDetail.vue?vue&type=template&id=09a70ffd&scoped=true&"
import script from "./ClassDetail.vue?vue&type=script&lang=js&"
export * from "./ClassDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassDetail.vue?vue&type=style&index=0&id=09a70ffd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a70ffd",
  null
  
)

export default component.exports